import React,{useEffect} from 'react'
import Footer from './Footer'
import Navbar from './Navbar'
import SupportEngine from './Support/SupportEngine'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
  

const Home = () => {



  return (
    <>
    
<SupportEngine/>

<Navbar/>
  
  <div className='a-few-slogans'>
<div className='p-div'>
<p className='left-text no-over'>AI Enthusiast</p>
<p className='middle-text no-over'>Hey, I'm Chris🤙</p>
<p className='right-text no-over'>npx create-react-app</p>


</div>
  </div>
     
{/* <p className='no-over'>Visitors' IP: <span id="ip"></span></p> */}
       <section>

<div className='video-section mlot'>


      
<iframe src="https://open.spotify.com/embed/playlist/0vvXsWCC9xrXsKd4FyS8kM?utm_source=generator"  frameBorder="0" autoPlay allowFullScreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy" className=' spotify-player'> 
</iframe></div> 

{/* <section className="weblinks-list list mlot footer"> */}



{/* </section>  */}
</section>


<Footer/>
    </>
  )
}

export default Home
